module.exports = __webpack_public_path__ + "img/success_icon.34c544a0.png";